<template>
  <div id="supMaterialC">
    <el-row>
      <el-col :span="9" :offset="0.5">
        <el-row>
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item>
              <span>请选择订单号:</span>
            </el-form-item>
            <el-form-item>
              <el-select v-model="orderId" placeholder="请选择">
                <el-option v-for="item in orders" :key="item.id" :label="item.id" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button :loading="startloading" type="primary" @click="startChooes" v-if="orders.length!=0&&orderId!=''" :disabled="isChoose">开始选材</el-button>
              <span v-if="orders.length==0">无可选订单</span>

            </el-form-item>
          </el-form>
        </el-row>
        <el-row>
          <OrderLabel :order='order' :disabled='true' :label='label' :files='files' v-if="orderId" :users='users'></OrderLabel>
        </el-row>
      </el-col>

      <el-col :span="12" v-if="isChoose==true" style="margin: 10px 0px 0px 10px;height: 100%">
        <h3 style="text-align: center; margin: 10px 10px 40px 0px">材料种类: {{label.material}}</h3>
        <div style="text-align: center">

          <!-- 第一步 -->
          <el-transfer v-if="activate==0" style="text-align: left; display: inline-block" v-model="chooseM" filterable :titles="['材料宽度', '已选']" :button-texts="['剔除', '选取']" :data="allMaterial">
            <el-button slot="left-footer" type="warning" size="small" style="width:100%; height:100%" @click="resetMaterial">重置</el-button>
            <el-button slot="right-footer" type="primary" size="small" style="width:100%; height:100%" @click="next">下一步</el-button>
          </el-transfer>

          <!-- 第二步 -->
          <el-form v-if="activate==1" label-width="80px" @submit.native.prevent>

            <el-row style="margin-bottom: 20px">
              <el-col :span="8">
                <span>宽度</span>
              </el-col>
              <el-col :span="16">
                <el-row>
                  <el-col :span="8">
                    <span>长度(米)</span>
                  </el-col>
                  <el-col :span="8">
                    <span>数量(卷)</span>
                  </el-col>
                  <el-col :span="8">
                    <span>移除</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>

            <template v-for="(value, key, index) in chooseDetail">
              <el-row style="margin-top:20px">
                <el-col :span='6' :offset="2">
                  <el-form-item :label="key+' mm'">
                    <el-button icon="el-icon-plus" circle type="primary" @click="addItme(key)"></el-button>
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <template v-for="(item, i) in value">
                    <el-row style="margin-bottom:8px">
                      <el-col :span="8">
                        <span>
                          <input type="number" v-model="item.prepareM" style="width:88%;height:30px;text-align:center"></input>
                        </span>
                      </el-col>
                      <el-col :span="8">
                        <span>
                          <input type="number" v-model="item.rollNum" style="width:88%;height:30px;text-align:center"></input>
                        </span>
                      </el-col>
                      <el-col :span="8">
                        <el-button icon="el-icon-minus" circle type="warning" @click="removeItem(key,i)"></el-button>
                      </el-col>
                    </el-row>
                  </template>
                </el-col>
              </el-row>
            </template>

            <el-button @click="back">上一步</el-button>
            <el-button type="primary" @click="next">确 定</el-button>
          </el-form>

          <!-- 第三步 -->
          <div v-if="activate==2">
            <el-row>
              <el-col :offset="5" :span="18">
                <table border="1" cellspacing="0" style="width: 80%">
                  <tr>
                    <th>宽度(mm)</th>
                    <th>长度(米)</th>
                    <th>数量(卷)</th>
                  </tr>
                  <template v-for="(value, key, index) in chooseDetail">
                    <template v-for="(item, i) in value">
                      <tr>
                        <td v-if="i==0" :rowspan='chooseDetail[key].length'>{{key}}</td>
                        <td>{{item.prepareM}}</td>
                        <td>{{item.rollNum}}</td>
                      </tr>
                    </template>
                  </template>
                </table>
              </el-col>
            </el-row>
            <el-row style="margin-top: 30px">
              <el-button @click="back">上一步</el-button>
              <el-button type="primary" @click="commit">确 定</el-button>
            </el-row>
          </div>

          <!-- <el-table :data="chooseDetail"  border style="width: 100%; margin-top: 20px">
            <el-table-column prop="id" label="ID" width="180">
            </el-table-column>

          </el-table> -->
        </div>
      </el-col>

      <!-- 状态栏 -->
      <el-col :span="2" v-if="isChoose==true" style="margin-top: 80px">
        <div style="height: 300px;">
          <el-steps direction="vertical" :active="activate" finish-status="success">
            <el-step title="选宽度"></el-step>
            <el-step title="输长度"></el-step>
            <el-step title="提交"></el-step>
          </el-steps>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import OrderLabel from "@/components/production/OrderLabel";
import Vue from "vue";
export default {
  components: {
    OrderLabel
  },
  data: function() {
    return {
      orders: [],
      //终端发出
      postApi: {
        crud: "",
        info: {}
      },
      //终端接收
      message: {
        result: {
          infos: []
        }
      },
      orderId: "",

      //订单信息
      order: {},

      //标签信息
      label: {},


      //相关人员信息
      users: {},

      //附件信息
      files: {},

      startloading: false,

      activate: 0,

      //选取信息
      allMaterial: [],
      chooseM: [],
      isChoose: false,

      //选择明细
      chooseDetail: {},

      orderStatus: 2,
    };
  },
  created: function() {
    this.init();
  },
  watch: {
    orderId: async function(val) {
      if (val != "") {
        this.postApi.crud = "ri";
        this.postApi.info = {
          key: val
        };
        this.message = await this.$doPost(
          "/api/production/order",
          this.postApi
        );
        if (this.message.msgCode == 0) {
          this.order = this.message.result.infos.order;
          // this.order.id = this.order.id.substring(0, 5);
          this.label = this.message.result.infos.label;
          this.files = this.message.result.infos.files;
          this.users = this.message.result.infos.users;
        } else {
          this.$message.error(this.message.msg);
        }
      }
      //关闭选择
      this.isChoose = false;
      this.chooseM = [];
      this.allMaterial = [];
      this.chooseDetail = {};
      this.activate = 0;
    }
  },
  methods: {
    init: async function() {
      this.orderId = "";

      this.postApi.crud = "r";
      this.postApi.info = {
        key: {
          id: "",
          superSearch: true,
          orderStatus: this.orderStatus,
          searchTime: null
        }
      };
      this.message = await this.$doPost("/api/production/order", this.postApi);
      if (this.message.msgCode == 0) {
        this.orders = this.message.result.infos;
      } else {
        this.$message.error(this.message.msg);
        this.orders = [];
      }
    },
    startChooes: async function() {
      this.startloading = true;
      this.postApi.crud = "ri";
      this.postApi.info = {
        key: this.label
      };
      this.message = await this.$doPost(
        "/api/basedata/materialattribute",
        this.postApi
      );
      if (this.message.msgCode == 0) {
        this.allMaterial = this.message.result.infos.allMaterial;
        this.chooseM = this.message.result.infos.chooseM;
        this.isChoose = true;
      } else {
        this.$message.error(this.message.msg);
      }
      this.startloading = false;
    },
    resetMaterial: function() {
      this.chooseM = [];
      this.chooseDetail = {};
      this.activate = 0;
    },
    next: function() {
      var error = "";
      if (this.activate == 0) {
        if (this.chooseM.length == 0) {
          error += "请选取材料";
        }
        for (var itme in this.chooseM) {
          this.chooseDetail[this.chooseM[itme]] = [{ prepareM: 0, rollNum: 0 }];
        }
      } else if (this.activate == 1) {
        for (var itme in this.chooseDetail) {
          if (error != "") break;
          for (var i in this.chooseDetail[itme]) {
            if (
              this.chooseDetail[itme][i].prepareM <= 0 ||
              this.chooseDetail[itme][i].prepareM == "" ||
              this.chooseDetail[itme][i].rollNum <= 0 ||
              this.chooseDetail[itme][i].rollNum == ""
            ) {
              error += "只能输入正数";
              break;
            }
          }
        }
      }
      if (error === "") {
        this.activate += 1;
      } else {
        this.$message.warning(error);
      }
    },
    back: function() {
      if (this.activate == 1) {
        this.chooseDetail = {};
      }
      this.activate -= 1;
    },
    addItme: function(item) {
      // console.log(this.chooseDetail[item.toString()]);
      this.chooseDetail[item].push({ prepareM: 0, rollNum: 0 });
      // var list = this.chooseDetail[item].concat();
      // console.log(list)
      // Vue.set(this.chooseDetail[item],this.chooseDetail[item].length-1,{ prepareM: 1, rollNum: 2 });
      // Vue.set(this.chooseDetail,item.toString(),list);
      this.$forceUpdate();
    },
    removeItem: function(key, i) {
      if (this.chooseDetail[key].length > 1) {
        this.chooseDetail[key].splice(i, 1);
        this.$forceUpdate();
      } else {
        this.$message.warning("至少保存一项");
      }
    },
    commit: async function() {
      this.postApi.crud = "c";
      this.postApi.info = {
        material: this.label.material,
        orderId: this.orderId,
        choose: this.chooseDetail,
      };
      this.message = await this.$doPost(
        "/api/production/productioninfo",
        this.postApi
      );
      if (this.message.msgCode == 0) {
        this.$message.success("选材成功");
        this.init();
      } else {
        this.$message.error(this.message.msg);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>




// WEBPACK FOOTER //
// src/components/production/SupMaterialC.vue